import { InferType, object, string } from "yup";

export const supportProblemTypes = [
	"I can’t add a brand or item to an order.",
	"I can’t place an order.",
	"I need my order sooner.",
	"My order needs changes.",
	"My order has the wrong pricing.",
	"My order is missing.",
	"My order needs to be on or off Hold.",
	"The cabinets I ordered are damaged.",
	"The cabinets I ordered are missing."
];

export const supportCaseFormSchema = object({
	problemType: string().trim().required("Type of problem is required."),
	name: string().trim().required("Name is required."),
	email: string().trim().email("Enter a valid email address.").required("Email is required."),
	description: string()
		.trim()
		.required("Describe the problem.")
		.max(500, "Description cannot exceed 500 characters."),
	url: string()
		.trim()
		.optional()
		.test("website", "Enter a valid http or https URL.", (value) => {
			if (!value) return true;
			try {
				return ["http:", "https:"].includes(new URL(value).protocol);
			} catch {
				return false;
			}
		})
});

export type SupportCaseFormData = InferType<typeof supportCaseFormSchema>;
